var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",attrs:{"disabled":_vm.disabled},on:{"click":_vm.buttonClick}},[(!_vm.isLoading)?_vm._t("default"):_c('div',[_c('vue-loading',{attrs:{"type":"spin","color":"#ffffff","size":{ width: '30px', height: '30px' }}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7d88d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/GbButton.vue
// module id = null
// module chunks = 